/**
 * @generated SignedSource<<55d03f23448e8e4ebb29efe0ef2245e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentNotificationEmailCtaButton = "disabled" | "enabled" | "%future added value";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
export type ContentUsageStatus = "draft" | "published" | "%future added value";
export type ContentUsageSubmissionMethod = "mark_as_complete" | "submission" | "%future added value";
export type ContentUsageSubmissionVisibility = "cohort" | "member_group" | "private" | "%future added value";
export type MessageTemplateKind = "community_welcome" | "course_welcome" | "custom" | "product_completion" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type UpdateContentUsageInput = {
  botResponseIds?: ReadonlyArray<string> | null;
  content?: EditContentInput | null;
  contentId?: string | null;
  contentSystemTaskKind?: ContentSystemTaskKind | null;
  contentType?: ContentType | null;
  contentUsageId?: string | null;
  contentUsageInput?: ContentUsageInput | null;
  detachFromContent?: boolean | null;
  enableChildDefaultTimeEstimate?: boolean | null;
  organizationId: string;
  productId?: string | null;
  timeEstimateMinutes?: number | null;
};
export type ContentUsageInput = {
  confirmationModalInput?: EditContentInput | null;
  dueAt?: string | null;
  dueDateUpdatedEmailMessageInput?: MessageTemplateInput | null;
  entity?: ContentUsageEntity | null;
  entityId?: string | null;
  occurrences?: ReadonlyArray<string> | null;
  ordering?: number | null;
  passPercentage?: number | null;
  prerequisiteIds?: ReadonlyArray<string> | null;
  releasedAt?: string | null;
  requireScormCompletion?: boolean | null;
  showComments?: boolean | null;
  status?: ContentUsageStatus | null;
  submissionFormat?: AssignmentSubmissionFormatInput | null;
  submissionMethod?: ContentUsageSubmissionMethod | null;
  submissionVisibility?: ContentUsageSubmissionVisibility | null;
};
export type MessageTemplateInput = {
  chatContent?: ChatContentInput | null;
  emailContent?: EmailContentInput | null;
  id?: string | null;
  kind?: MessageTemplateKind | null;
  name: string;
  slackContent?: SlackContentInput | null;
};
export type EmailContentInput = {
  bccEmails?: ReadonlyArray<string> | null;
  bccUserIds?: ReadonlyArray<string> | null;
  ccEmails?: ReadonlyArray<string> | null;
  ccUserIds?: ReadonlyArray<string> | null;
  richBody: string;
  send: boolean;
  subject: string;
};
export type SlackContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type ChatContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type AssignmentSubmissionFormatInput = {
  file: AssignmentSubmissionFormatSettingsInput;
  link: AssignmentSubmissionFormatSettingsInput;
  text: AssignmentSubmissionFormatSettingsInput;
};
export type AssignmentSubmissionFormatSettingsInput = {
  enabled: boolean;
  required: boolean;
};
export type EditContentInput = {
  attachments?: ReadonlyArray<ContentAttachmentInput> | null;
  contentLabelId?: string | null;
  coverAudio?: string | null;
  coverAudioAssetId?: string | null;
  coverPhoto?: string | null;
  coverPhotoAssetId?: string | null;
  coverVideo?: string | null;
  coverVideoAssetId?: string | null;
  coverVideoDurationSeconds?: number | null;
  ctaAppId?: string | null;
  ctaText?: string | null;
  description?: string | null;
  isAiGenerated?: boolean | null;
  name?: string | null;
  notificationEmailCtaButton?: ContentNotificationEmailCtaButton | null;
  notificationEmailSubject?: string | null;
  releaseDatetime?: string | null;
  releaseNow?: boolean | null;
  richEditorDescriptionContent?: string | null;
  richEditorNotificationEmailBodyContent?: string | null;
  sendNotificationEmail?: boolean | null;
  showComments?: boolean | null;
  showCoverPlayIcon?: boolean | null;
  submissionLink?: string | null;
  thumbnailAssetId?: string | null;
  thumbnailUrl?: string | null;
  timeEstimateMinutes?: number | null;
  webFormRevision?: CreateWebFormRevisionInput | null;
};
export type ContentAttachmentInput = {
  id?: string | null;
  mediaAssetId?: string | null;
  mediaUrl?: string | null;
  name?: string | null;
};
export type CreateWebFormRevisionInput = {
  contentUsageId?: string | null;
  questions: ReadonlyArray<WebFormQuestionInput>;
  webFormId: string;
};
export type WebFormQuestionInput = {
  answerKey?: WebFormQuestionAnswerKeyInput | null;
  isRequired?: boolean | null;
  options?: ReadonlyArray<WebFormQuestionOptionInput> | null;
  richEditorBody: string;
  type: WebFormQuestionType;
};
export type WebFormQuestionOptionInput = {
  id: string;
  label: string;
};
export type WebFormQuestionAnswerKeyInput = {
  correctIds: ReadonlyArray<string>;
  feedback?: string | null;
};
export type ContentUsageAssociateEventsButtonMutation$variables = {
  input: UpdateContentUsageInput;
};
export type ContentUsageAssociateEventsButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ContentModuleListItemFragment" | "ContentUsageAssociateEventsButtonFragment">;
    } | null;
  };
};
export type ContentUsageAssociateEventsButtonMutation = {
  response: ContentUsageAssociateEventsButtonMutation$data;
  variables: ContentUsageAssociateEventsButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v12 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v9/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v9/*: any*/),
  (v11/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v9/*: any*/),
        (v11/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v9/*: any*/),
        (v11/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v13/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = [
  (v8/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrerequisites",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentUsageAssociateEventsButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateContentUsageResponse",
        "kind": "LinkedField",
        "name": "updateContentUsage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ContentUsageAssociateEventsButtonFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ContentModuleListItemFragment"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentUsageAssociateEventsButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateContentUsageResponse",
        "kind": "LinkedField",
        "name": "updateContentUsage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "productId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "occurrences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Occurrence",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coverPhoto",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplete",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "datetimeRange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cover",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupNodeConnection",
                                "kind": "LinkedField",
                                "name": "memberGroups",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroupNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentMemberGroupId",
                                            "storageKey": null
                                          },
                                          (v4/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "color",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "role",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSystem",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OccurrenceRSVPNodeConnection",
                            "kind": "LinkedField",
                            "name": "rsvps",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNodeConnection",
                            "kind": "LinkedField",
                            "name": "attendees",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v4/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeEstimateMinutes",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentCompletionNodeConnection",
                    "kind": "LinkedField",
                    "name": "viewerChildContentCompletions",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "createCurriculumModuleItemContentUsageButtonChildren",
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": "allChildren",
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "dependents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v21/*: any*/),
                              (v4/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "contentLabelId",
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueAt",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "module",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v29/*: any*/),
                              (v4/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "passPercentage",
                            "storageKey": null
                          },
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "module",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "systemTaskKind",
                                    "storageKey": null
                                  },
                                  (v21/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "productApp",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customAppTitle",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32c0aae472c5b6b5cee0339c0fc37988",
    "id": null,
    "metadata": {},
    "name": "ContentUsageAssociateEventsButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ContentUsageAssociateEventsButtonMutation(\n  $input: UpdateContentUsageInput!\n) {\n  response: updateContentUsage(input: $input) {\n    node {\n      id\n      ...ContentUsageAssociateEventsButtonFragment\n      ...ContentModuleListItemFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment ContentModuleAdminDropdownFragment on ContentUsage {\n  id\n  entity\n  ...CreateContentModuleItemButtonFragment\n  ...UpdateContentModuleButtonFragment\n  ...DeleteContentUsageButtonFragment\n  ...ContentUsageAssociateEventsButtonFragment\n}\n\nfragment ContentModuleEventsListItem_OccurrenceFragment on Occurrence {\n  id\n  name\n  coverPhoto\n  isComplete\n  datetimeRange\n  product {\n    cover\n    name\n    id\n  }\n  event {\n    id\n    ...MemberGroupEventTagListFragment\n    ...usePermissionsFragment\n    memberGroups {\n      totalCount\n    }\n  }\n  rsvps {\n    totalCount\n  }\n  attendees {\n    totalCount\n  }\n}\n\nfragment ContentModuleEvents_ContentUsageFragment on ContentUsage {\n  occurrences {\n    totalCount\n    edges {\n      node {\n        id\n        ...ContentModuleEventsListItem_OccurrenceFragment\n      }\n    }\n  }\n}\n\nfragment ContentModuleListItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  isLocked\n  hasPrerequisites\n  content {\n    id\n    type\n    name\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          isLocked\n          hasPrerequisites\n          content {\n            timeEstimateMinutes\n            id\n          }\n        }\n      }\n    }\n    viewerChildContentCompletions {\n      totalCount\n    }\n  }\n  occurrences {\n    totalCount\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleReleaseCountdownFragment\n  ...ContentModuleReleaseDateFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n  ...ContentModuleEvents_ContentUsageFragment\n  ...ContentUsageLockIconFragment\n}\n\nfragment ContentModuleReleaseCountdownFragment on ContentUsage {\n  releasedAt\n}\n\nfragment ContentModuleReleaseDateFragment on ContentUsage {\n  id\n  releasedAt\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageAssociateEventsButtonFragment on ContentUsage {\n  id\n  productId\n  organizationId\n  occurrences {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ContentUsageLockIconFragment on ContentUsage {\n  id\n  entity\n  content {\n    name\n    id\n  }\n  ...UpdateContentModuleButtonFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment CreateCollectionModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  content {\n    id\n  }\n  productId\n}\n\nfragment CreateContentModuleItemButtonFragment on ContentUsage {\n  id\n  entity\n  ...CreateCollectionModuleItemContentUsageButtonFragment\n  ...CreateCurriculumModuleItemContentUsageButtonFragment\n}\n\nfragment CreateCurriculumModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    id\n    createCurriculumModuleItemContentUsageButtonChildren: children {\n      totalCount\n    }\n  }\n  productId\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c5eaacaad9adc3c96b27eb25a9543b4";

export default node;
